import { createFileRoute, redirect } from '@tanstack/react-router';
import { parseLinkBioEditorTab } from '@/components/link-bio/link-bio-editor-sections';

/**
 * Bio Page moved into the Marketing workspace. This legacy path only redirects — keeping `?tab=` so
 * bookmarks like `/bio-page?tab=links` still open the same editor tab.
 */
export const Route = createFileRoute('/_auth/$orgId/bio-page')({
  validateSearch: (search: Record<string, unknown>) => ({ tab: parseLinkBioEditorTab(search.tab) }),
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: '/$orgId/marketing/bio-page', params, search: { tab: search.tab }, replace: true });
  },
});
